import React, { useEffect, useState, useRef } from 'react';
import MediaPlayer from '../utils/MediaPlayer';
import anime, { set } from 'animejs';
import '../css/common.css';
import '../css/button.css';
import ImageButton from '../utils/ImageButton';
import FramePlayer from '../utils/FramePlayer';
import lang from '../lang.json';

const Module5c3 = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module5c3;

    const [page, setPage] = useState(0);
    const [pause, setPause] = useState(true);
    const [reset, setReset] = useState(false);

    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const [show4, setShow4] = useState(false);
    const [show5, setShow5] = useState(false);
    const [show6, setShow6] = useState(false);
    const [show7, setShow7] = useState(false);
    const [show8, setShow8] = useState(false);
    const [show9, setShow9] = useState(false);
    const [show10, setShow10] = useState(false);
    const [show11, setShow11] = useState(false);

    useEffect(() => {
        var tl = anime.timeline({});
        //Fade out the intro image
        tl.add({
            targets: '#introimage',
            opacity: 0,
            duration: 3000,
            easing: 'easeInOutQuint',
        }, '2500')
            //Fade in the player
            .add({
                targets: '#player',
                opacity: 1,
                duration: 3000,
                easing: 'easeInOutQuint',
            }, '2500')
            //Display the buttons and the text
            .add({
                targets: ['.buttonApparition', '.t1'],
                opacity: 1,
                duration: 2000,
                easing: 'easeInOutQuint',
            }, '6600')

        //play a mp3 file
        var audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module5c3.mp3");
        audio.play();
        props.audio.push(audio)

        //sous titres
        let tl2 = anime.timeline({})
        //dabord opacity 0 pour tous
        tl2.add({
            targets: '.st',
            opacity: 0,
            duration: 1,
        })
            .add({
                targets: '.st1',
                opacity: 1,
                duration: 1,
            }, 500)
            .add({
                targets: '.st1',
                opacity: 0,
                duration: 1,
            }, 2500)

    }, []);

    function play() {
        setReset(true);
        setPause(false);
        setTimeout(() => {
            setReset(false);
        }, 200);
    }

    return (<>
        <div className="background" >
            <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/1.jpg"}
                alt="background"
                id="introimage"
                style={
                    { zIndex: 1 }}
            /> <div id="player"
                style={
                    { position: 'absolute', top: '0px', zIndex: 2, width: 660, opacity: 0 }} >
                <FramePlayer dirName="module5c3"
                    ext="png"
                    frameNumber={27}
                    fps={12}
                    initialDelay={5000}
                    style={
                        { position: 'absolute', top: '50px', zIndex: 2, width: 660 }}
                /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/2.png"}
                    alt="background"
                    style={
                        { position: 'absolute', top: 225, left: 0, width: 660 }}
                /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/3.png"}
                    alt="background"
                    style={
                        { position: 'absolute', top: 265, left: 18, width: 70 }}
                /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/5.png"}
                    alt="background"
                    style={
                        { position: 'absolute', top: 313, left: 30, width: 25, zIndex: 4, cursor: "pointer" }}
                    className='inflateButton'
                    onClick={
                        () => play()}
                /> { /* boutons */}
                <ImageButton classNameForButton="inflateButtonMore buttonApparition"
                    dirName="module5c3"
                    id="6"
                    x={135}
                    y={159}
                    callback={
                        () => setPage(0)}
                    style={
                        { zIndex: 2, opacity: 0 }}
                    onMouseEnter={
                        () => setShow1(true)}
                    onMouseLeave={
                        () => setShow1(false)}
                />
                <ImageButton classNameForButton="inflateButtonMore buttonApparition"
                    dirName="module5c3"
                    id="6"
                    x={182}
                    y={152}
                    callback={
                        () => setPage(1)}
                    style={
                        { zIndex: 2, opacity: 0 }}
                    onMouseEnter={
                        () => setShow2(true)}
                    onMouseLeave={
                        () => setShow2(false)}
                />
                <ImageButton classNameForButton="inflateButtonMore buttonApparition"
                    dirName="module5c3"
                    id="6"
                    x={229}
                    y={142}
                    callback={
                        () => setPage(2)}
                    style={
                        { zIndex: 2, opacity: 0 }}
                    onMouseEnter={
                        () => setShow3(true)}
                    onMouseLeave={
                        () => setShow3(false)}
                />
                <ImageButton classNameForButton="inflateButtonMore buttonApparition"
                    dirName="module5c3"
                    id="6"
                    x={274}
                    y={139}
                    callback={
                        () => setPage(3)}
                    style={
                        { zIndex: 2, opacity: 0 }}
                    onMouseEnter={
                        () => setShow4(true)}
                    onMouseLeave={
                        () => setShow4(false)}
                />
                <ImageButton classNameForButton="inflateButtonMore buttonApparition"
                    dirName="module5c3"
                    id="6"
                    x={319}
                    y={142}
                    callback={
                        () => setPage(4)}
                    style={
                        { zIndex: 2, opacity: 0 }}
                    onMouseEnter={
                        () => setShow5(true)}
                    onMouseLeave={
                        () => setShow5(false)}
                />
                <ImageButton classNameForButton="inflateButtonMore buttonApparition"
                    dirName="module5c3"
                    id="6"
                    x={363}
                    y={150}
                    callback={
                        () => setPage(5)}
                    style={
                        { zIndex: 2, opacity: 0 }}
                    onMouseEnter={
                        () => setShow6(true)}
                    onMouseLeave={
                        () => setShow6(false)}
                /> <ImageButton classNameForButton="inflateButtonMore buttonApparition"
                    dirName="module5c3"
                    id="6"
                    x={408}
                    y={156}
                    callback={
                        () => setPage(6)}
                    style={
                        { zIndex: 2, opacity: 0 }}
                    onMouseEnter={
                        () => setShow7(true)}
                    onMouseLeave={
                        () => setShow7(false)}
                />
                <ImageButton classNameForButton="inflateButtonMore buttonApparition"
                    dirName="module5c3"
                    id="6"
                    x={455}
                    y={146}
                    callback={
                        () => setPage(7)}
                    style={
                        { zIndex: 2, opacity: 0 }}
                    onMouseEnter={
                        () => setShow8(true)}
                    onMouseLeave={
                        () => setShow8(false)}
                />
                <ImageButton classNameForButton="inflateButtonMore buttonApparition"
                    dirName="module5c3"
                    id="6"
                    x={502}
                    y={151}
                    callback={
                        () => setPage(8)}
                    style={
                        { zIndex: 2, opacity: 0 }}
                    onMouseEnter={
                        () => setShow9(true)}
                    onMouseLeave={
                        () => setShow9(false)}
                />
                <ImageButton classNameForButton="inflateButtonMore buttonApparition"
                    dirName="module5c3"
                    id="6"
                    x={548}
                    y={144}
                    callback={
                        () => setPage(9)}
                    style={
                        { zIndex: 2, opacity: 0 }}
                    onMouseEnter={
                        () => setShow10(true)}
                    onMouseLeave={
                        () => setShow10(false)}
                /> <ImageButton classNameForButton="inflateButtonMore buttonApparition"
                    dirName="module5c3"
                    id="6"
                    x={594}
                    y={153}
                    callback={
                        () => setPage(10)}
                    style={
                        { zIndex: 2, opacity: 0 }}
                    onMouseEnter={
                        () => setShow11(true)}
                    onMouseLeave={
                        () => setShow11(false)}
                />


                {
                    page == 0 &&
                    <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/4.png"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 321, left: 143, width: 29 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/contemporaine_p.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 315, left: 84 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/contemporaine.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 252, left: 103, width: 498 }}
                        /> <FramePlayer
                            dirName="module5c3_contemporaine"
                            ext="png"
                            frameNumber={20}
                            fps={12}
                            paused={pause}
                            resetSignal={reset}
                            onEnd={() => { setPause(true); }}
                            style={
                                {
                                    position: 'absolute',
                                    top: 225,
                                    left: 85,
                                    zIndex: 2,
                                    width: 543,
                                    height: 198,
                                }}
                        /> </>} {
                    page == 1 &&
                    <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/4.png"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 321, left: 112, width: 29 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/musicien_p.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 315, left: 80 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/musicien.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 252, left: 103, width: 187 }}
                        /> <FramePlayer
                            dirName="module5c3_musicien"
                            ext="png"
                            frameNumber={20}
                            fps={12}
                            paused={pause}
                            resetSignal={reset}
                            onEnd={() => { setPause(true); }}
                            style={
                                {
                                    position: 'absolute',
                                    top: 223,
                                    left: -106,
                                    zIndex: 2,
                                    width: 420,
                                }}
                        /> </>} {
                    page == 2 &&
                    <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/4.png"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 321, left: 129, width: 29 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/amerique_p.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 315, left: 80 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/amerique.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 252, left: 103, width: 351 }}
                        /> <FramePlayer
                            dirName="module5c3_amerique"
                            ext="png"
                            frameNumber={20}
                            fps={12}
                            paused={pause}
                            resetSignal={reset}
                            onEnd={() => { setPause(true); }}
                            style={
                                {
                                    position: 'absolute',
                                    top: 226,
                                    left: -8,
                                    zIndex: 2,
                                    width: 466,
                                }}
                        /> </>} {
                    page == 3 &&
                    <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/4.png"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 321, left: 136, width: 29 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/autobiographique_p.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 315, left: 80 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/autobiographique.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 252, left: 108, width: 352 }}
                        /> <FramePlayer
                            dirName="module5c3_autobiographique"
                            ext="png"
                            frameNumber={20}
                            fps={12}
                            paused={pause}
                            resetSignal={reset}
                            onEnd={() => { setPause(true); }}
                            style={
                                { position: 'absolute', top: 225, left: 29, zIndex: 2, width: 457 }}
                        /> </>} {
                    page == 4 &&
                    <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/4.png"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 321, left: 174, width: 29 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/intermittent_p.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 315, left: 80 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/intermittent.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 252, left: 108, width: 486 }}
                        /> <FramePlayer
                            dirName="module5c3_intermittent"
                            ext="png"
                            frameNumber={20}
                            fps={12}
                            paused={pause}
                            resetSignal={reset}
                            onEnd={() => { setPause(true); }}
                            style={
                                { position: 'absolute', top: 244, left: 99, zIndex: 2, width: 508 }}
                        /> </>} {
                    page == 5 &&
                    <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/4.png"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 321, left: 112, width: 29 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/technologie_p.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 315, left: 80 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/technologie.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 248, left: 104, width: 257 }}
                        /> <FramePlayer
                            dirName="module5c3_technologie"
                            ext="png"
                            frameNumber={17}
                            fps={12}
                            paused={pause}
                            resetSignal={reset}
                            onEnd={() => { setPause(true); }}
                            style={
                                { position: 'absolute', top: 240, left: 98, zIndex: 2, width: 508 }}
                        />
                    </>
                }
                {
                    page == 6 &&
                    <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/4.png"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 318, left: 112, width: 29 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/oreille_p.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 315, left: 80 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/oreille.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 248, left: 104, width: 487 }}
                        /> <FramePlayer
                            dirName="module5c3_oreille"
                            ext="png"
                            frameNumber={20}
                            fps={12}
                            paused={pause}
                            resetSignal={reset}
                            onEnd={() => { setPause(true); }}
                            style={
                                { position: 'absolute', top: 241, left: 98, zIndex: 2, width: 494 }}
                        /> </>}
                {
                    page == 7 &&
                    <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/4.png"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 318, left: 162, width: 29 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/conservatoire_p.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 315, left: 80 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/conservatoire.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 251, left: 104, width: 286 }}
                        /> <FramePlayer
                            dirName="module5c3_conservatoire"
                            ext="png"
                            frameNumber={20}
                            fps={12}
                            paused={pause}
                            resetSignal={reset}
                            onEnd={() => { setPause(true); }}
                            style={
                                { position: 'absolute', top: 230, left: -121, zIndex: 2, width: 510 }}
                        /> </>
                }
                {
                    page == 8 &&
                    <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/4.png"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 320, left: 125, width: 29 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/alternative_p.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 315, left: 80 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/alternative.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 251, left: 104, width: 234 }}
                        /> <FramePlayer
                            dirName="module5c3_alternative"
                            ext="png"
                            frameNumber={20}
                            fps={12}
                            paused={pause}
                            resetSignal={reset}
                            onEnd={() => { setPause(true); }}
                            style={
                                { position: 'absolute', top: 241, left: 102, zIndex: 2, width: 233 }}
                        /> </>} {
                    page == 9 && <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/4.png"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 320, left: 125, width: 29 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/communiste_p.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 315, left: 80 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/communiste.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 251, left: 111, width: 234 }}
                        /> <FramePlayer
                            dirName="module5c3_communiste"
                            ext="png"
                            frameNumber={20}
                            fps={12}
                            paused={pause}
                            resetSignal={reset}
                            onEnd={() => { setPause(true); }}
                            style={
                                { position: 'absolute', top: 223, left: -55, zIndex: 2, width: 442 }}
                        /> </>} {
                    page == 10 &&
                    <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/4.png"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 320, left: 112, width: 29 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/proprietaire_p.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 315, left: 80 }}
                        /> <img src={process.env.PUBLIC_URL + "/assets/images/module5c3/proprietaire.svg"}
                            alt="background"
                            style={
                                { position: 'absolute', top: 251, left: 111, width: 238 }}
                        /> <FramePlayer
                            dirName="module5c3_proprietaire"
                            ext="png"
                            frameNumber={20}
                            fps={12}
                            paused={pause}
                            resetSignal={reset}
                            onEnd={() => { setPause(true); }}
                            style={
                                { position: 'absolute', top: 225, left: -55, zIndex: 2, width: 442 }}
                        />
                    </>}
            </div>
            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>

            {/* sous titres */}
            <p
                className="st1 st"
                style={{
                    position: 'absolute',
                    top: '442px',
                    left: '10px',
                    opacity: 1,
                    color: 'white',
                    backgroundColor: 'black',
                    backgroundOpacity: 0.5,
                    padding: '5px',
                }}
            >
                {texts.lang24}
            </p>
            <p
                className="t1"
                style={{
                    position: 'absolute',
                    left: 150,
                    top: 30,
                    width: 470,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15,
                    opacity: 0,
                }}
            >{texts.lang30}</p>

            {/*legendes*/}
            <p
                style={{
                    position: 'absolute',
                    left: 107,
                    fontSize: '12px',
                    top: 175,
                    color: 'orange',
                    textAlign: 'center',
                    zIndex: 5,
                    display: show1 ? 'block' : 'none',
                    cursor: 'pointer'
                }}
            >musique<br />contemporaine
            </p>
            <p
                style={{
                    position: 'absolute',
                    left: 177,
                    fontSize: '12px',
                    top: 175,
                    color: 'orange',
                    textAlign: 'center',
                    zIndex: 5,
                    display: show2 ? 'block' : 'none',
                    cursor: 'pointer'
                }}
            >musicien
            </p>
            <p
                style={{
                    position: 'absolute',
                    left: 212,
                    fontSize: '12px',
                    top: 164,
                    color: 'orange',
                    textAlign: 'center',
                    zIndex: 5,
                    display: show3 ? 'block' : 'none',
                    cursor: 'pointer'
                }}
            >vive <br />l'amérique !
            </p>
            <p
                style={{
                    position: 'absolute',
                    left: 242,
                    fontSize: '12px',
                    top: 162,
                    color: 'orange',
                    textAlign: 'center',
                    zIndex: 5,
                    display: show4 ? 'block' : 'none',
                    cursor: 'pointer'
                }}
            >autobiographique
            </p>
            <p
                style={{
                    position: 'absolute',
                    left: 296,
                    fontSize: '12px',
                    top: 162,
                    color: 'orange',
                    textAlign: 'center',
                    zIndex: 5,
                    display: show5 ? 'block' : 'none',
                    cursor: 'pointer'
                }}
            >intermittent <br />du spectacle
            </p>
            <p
                style={{
                    position: 'absolute',
                    left: 343,
                    fontSize: '12px',
                    top: 169,
                    color: 'orange',
                    textAlign: 'center',
                    zIndex: 5,
                    display: show6 ? 'block' : 'none',
                    cursor: 'pointer'
                }}
            >technologie
            </p>
            <p
                style={{
                    position: 'absolute',
                    left: 389,
                    fontSize: '12px',
                    top: 169,
                    color: 'orange',
                    textAlign: 'center',
                    zIndex: 5,
                    display: show7 ? 'block' : 'none',
                    cursor: 'pointer'
                }}
            >désagréable <br />à l'oreille
            </p>
            <p
                style={{
                    position: 'absolute',
                    left: 437,
                    fontSize: '12px',
                    top: 164,
                    color: 'orange',
                    textAlign: 'center',
                    zIndex: 5,
                    display: show8 ? 'block' : 'none',
                    cursor: 'pointer'
                }}
            >conservatoire
            </p>
            <p
                style={{
                    position: 'absolute',
                    left: 487,
                    fontSize: '12px',
                    top: 164,
                    color: 'orange',
                    textAlign: 'center',
                    zIndex: 5,
                    display: show9 ? 'block' : 'none',
                    cursor: 'pointer'
                }}
            >alternative
            </p>
            <p
                style={{
                    position: 'absolute',
                    left: 535,
                    fontSize: '12px',
                    top: 161,
                    color: 'orange',
                    textAlign: 'center',
                    zIndex: 5,
                    display: show10 ? 'block' : 'none',
                    cursor: 'pointer'
                }}
            >communiste
            </p>
            <p
                style={{
                    position: 'absolute',
                    left: 579,
                    fontSize: '12px',
                    top: 165,
                    color: 'orange',
                    textAlign: 'center',
                    zIndex: 5,
                    display: show11 ? 'block' : 'none',
                    cursor: 'pointer'
                }}
            >propriétaire
            </p>
        </div>
    </>
    );
}

export default Module5c3;